import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { Rocket, Check, BookOpen, Shield, Zap, Star, Layout, Target, Sparkles, ArrowRight } from 'lucide-react';
import { Button } from './ui/Button';
export function ProductSection() {
  const mainFeatures = [{
    icon: <Target className="w-5 h-5 text-brand-yellow" data-id="element-236" />,
    title: 'Metodología Paso a Paso',
    desc: 'Desde el lavado inicial hasta el sellado cerámico profesional.'
  }, {
    icon: <Layout className="w-5 h-5 text-brand-yellow" data-id="element-237" />,
    title: 'Guía de Productos',
    desc: 'Lista exacta de qué comprar y qué evitar para no tirar plata.'
  }, {
    icon: <Zap className="w-5 h-5 text-brand-yellow" data-id="element-238" />,
    title: 'Técnicas de Pulido',
    desc: 'Secretos para eliminar rayas y devolver el brillo de salón.'
  }, {
    icon: <Shield className="w-5 h-5 text-brand-yellow" data-id="element-239" />,
    title: 'Protección Extrema',
    desc: 'Cómo aplicar ceras, selladores y recubrimientos de larga duración.'
  }];
  return <section className="py-24 px-4 relative overflow-hidden pt-[48px] pb-[48px]" data-id="element-240">
      {/* Background Decorative Elements */}
      <div className="absolute top-0 left-1/4 w-[500px] h-[500px] bg-brand-yellow/5 blur-[120px] rounded-full pointer-events-none" data-id="element-241" />
      <div className="absolute bottom-0 right-1/4 w-[500px] h-[500px] bg-brand-yellow/5 blur-[120px] rounded-full pointer-events-none" data-id="element-242" />

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-243">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-20" data-id="element-244">
          <h2 className="text-3xl md:text-6xl font-black mb-6 tracking-tighter leading-[1.1] max-w-4xl mx-auto" data-id="element-245">
            <span className="text-white" data-id="element-246">Accedé al sistema principal</span>
            <br data-id="element-247" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-brand-yellow via-brand-gold to-brand-yellow" data-id="element-248">
              + 5 bonos estratégicos
            </span>
          </h2>
          <p className="text-lg md:text-2xl text-gray-400 font-medium tracking-tight max-w-2xl mx-auto" data-id="element-249">
            Para aprender, profesionalizarte y{' '}
            <span className="text-white italic" data-id="element-250">ampliar tus oportunidades</span>
            .
          </p>
        </motion.div>

        <div className="grid lg:grid-cols-12 gap-12 items-center" data-id="element-251">
          {/* Left: Book Showcase */}
          <div className="lg:col-span-6 relative" data-id="element-252">
            <motion.div initial={{
            opacity: 0,
            scale: 0.8
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} className="relative z-10" data-id="element-253">
              {/* Floating Animation Wrapper */}
              <motion.div animate={{
              y: [0, -20, 0]
            }} transition={{
              duration: 6,
              repeat: Infinity,
              ease: 'easeInOut'
            }} className="relative" data-id="element-254">
                {/* Premium Background Stage */}
                <div className="absolute inset-0 flex items-center justify-center pointer-events-none" data-id="element-255">
                  {/* Outer golden ring */}
                  <div className="absolute w-[500px] h-[500px] rounded-full border border-brand-yellow/10" data-id="element-256" />
                  <div className="absolute w-[420px] h-[420px] rounded-full border border-brand-yellow/15" data-id="element-257" />
                  {/* Core glow */}
                  <div className="w-[460px] h-[460px] rounded-full" style={{
                  background: 'radial-gradient(circle, rgba(245, 197, 24, 0.25) 0%, rgba(255, 215, 0, 0.12) 35%, rgba(245, 197, 24, 0.04) 60%, transparent 80%)'
                }} data-id="element-258" />
                </div>

                {/* Animated pulsing glow behind image */}
                <motion.div animate={{
                opacity: [0.4, 0.8, 0.4],
                scale: [0.95, 1.05, 0.95]
              }} transition={{
                duration: 3,
                repeat: Infinity,
                ease: 'easeInOut'
              }} className="absolute inset-0 flex items-center justify-center pointer-events-none" data-id="element-259">
                  <div className="w-[380px] h-[380px] bg-brand-yellow/20 blur-[100px] rounded-full" data-id="element-260" />
                </motion.div>

                <a href="#compra" onClick={e => {
                e.preventDefault();
                document.querySelector('#compra')?.scrollIntoView({
                  behavior: 'smooth'
                });
              }} className="relative block group/book" data-id="element-261">
                  <motion.img src="https://cdn.magicpatterns.com/uploads/kKovg1C9GJgZ6ijEL8mNkj/2cd60830-b589-4dca-8dc8-c21361d7b11d.webp" alt="Libro Principal y Bonos" width={772} height={772} loading="lazy" className="w-full max-w-[772px] mx-auto drop-shadow-[0_40px_80px_rgba(245,197,24,0.4)] cursor-pointer relative z-10" whileHover={{
                  scale: 1.06
                }} transition={{
                  type: 'spring',
                  stiffness: 200,
                  damping: 15
                }} data-id="element-262" />
                  {/* CTA overlay on hover - Hidden on mobile for better touch UX */}
                  <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-20 opacity-0 group-hover/book:opacity-100 transition-all duration-500 translate-y-2 group-hover/book:translate-y-0 hidden md:block" data-id="element-263">
                    <div className="bg-gradient-to-r from-brand-yellow via-[#FFD700] to-brand-yellow text-black font-black text-sm md:text-base px-6 py-2.5 rounded-full shadow-[0_0_30px_rgba(245,197,24,0.5)] flex items-center gap-2 whitespace-nowrap" data-id="element-264">
                      <Sparkles className="w-4 h-4" data-id="element-265" />
                      ACCEDER AL PRODUCTO
                      <ArrowRight className="w-4 h-4" data-id="element-266" />
                    </div>
                  </div>
                </a>
              </motion.div>

              {/* Decorative badges */}
              <motion.div initial={{
              opacity: 0,
              x: 20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} transition={{
              delay: 0.5
            }} className="absolute -right-4 top-1/4 bg-black/80 backdrop-blur-md border border-brand-yellow/30 p-4 rounded-2xl shadow-2xl z-20 hidden md:block" data-id="element-267">
                <div className="flex items-center gap-3" data-id="element-268">
                  <div className="bg-brand-yellow/20 p-2 rounded-lg" data-id="element-269">
                    <BookOpen className="w-6 h-6 text-brand-yellow" data-id="element-270" />
                  </div>
                  <div data-id="element-271">
                    <p className="text-white font-black text-sm uppercase" data-id="element-272">
                      Contenido Premium
                    </p>
                    <p className="text-gray-400 text-xs" data-id="element-273">
                      +150 páginas de valor
                    </p>
                  </div>
                </div>
              </motion.div>
            </motion.div>
          </div>

          {/* Right: Content Breakdown */}
          <div className="lg:col-span-6 space-y-8" data-id="element-274">
            <motion.div initial={{
            opacity: 0,
            x: 50
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} className="space-y-6 flex flex-col items-center lg:items-start text-center lg:text-left" data-id="element-275">
              <div className="grid sm:grid-cols-2 gap-4 w-full" data-id="element-276">
                {mainFeatures.map((feature, i) => <motion.div key={i} initial={{
                opacity: 0,
                y: 20
              }} whileInView={{
                opacity: 1,
                y: 0
              }} viewport={{
                once: true
              }} transition={{
                delay: i * 0.1
              }} className="bg-white/5 border border-white/10 p-5 rounded-2xl hover:border-brand-yellow/30 transition-all group flex flex-col items-center lg:items-start" data-id="element-277">
                    <div className="mb-3 transform group-hover:scale-110 transition-transform" data-id="element-278">
                      {feature.icon}
                    </div>
                    <h4 className="text-white font-bold mb-1" data-id="element-279">
                      {feature.title}
                    </h4>
                    <p className="text-gray-400 text-sm leading-relaxed" data-id="element-280">
                      {feature.desc}
                    </p>
                  </motion.div>)}
              </div>

              <div className="pt-6 w-full" data-id="element-281">
                <Button className="w-full lg:w-auto text-lg px-12 py-6 h-auto" data-id="element-282">
                  SÍ, QUIERO LA OFERTA AHORA
                </Button>
                <p className="text-gray-500 text-xs mt-4 text-center lg:text-left flex items-center justify-center lg:justify-start gap-2" data-id="element-283">
                  <Shield className="w-3 h-3" data-id="element-284" />
                  Acceso inmediato y garantía de satisfacción
                </p>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>;
}